import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';

import { ListingModule } from '../listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { VarModule } from '../../directives/ngVar';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { EditProviderEndpointDialog } from './edit-provider-endpoint-dialog.component';
import {  MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [
    EditProviderEndpointDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatSelectModule,
    ListingModule,
    DirectivesModule,
    ReactiveFormsModule,
    VarModule
  ],
  exports: [
    EditProviderEndpointDialog
  ]
})
export class EditProviderEndpointDialogModule {}
